// Theme generated from https://developer.microsoft.com/en-us/fabric#/styles/themegenerator

export const dark = {
  palette: {
    themePrimary: '#2196f0',
    themeLighterAlt: '#01060a',
    themeLighter: '#051826',
    themeLight: '#0a2d48',
    themeTertiary: '#145a90',
    themeSecondary: '#1e84d3',
    themeDarkAlt: '#37a0f1',
    themeDark: '#54aef3',
    themeDarker: '#80c3f6',
    neutralLighterAlt: '#121212',
    neutralLighter: '#1c1c1c',
    neutralLight: '#2c2c2c',
    neutralQuaternaryAlt: '#353535',
    neutralQuaternary: '#3d3d3d',
    neutralTertiaryAlt: '#5e5e5e',
    neutralTertiary: '#fdfdfd',
    neutralSecondary: '#fefefe',
    neutralPrimaryAlt: '#fefefe',
    neutralPrimary: '#fdfcfc',
    neutralDark: '#fefefe',
    black: '#ffffff',
    white: '#070707',
    blueMid: '#6cb8f6',
    green: '#00a100'
  },
  semanticColors: {
    messageText: '#f3f2f1',
    infoBackground: '#1b1a19',
    infoIcon: '#c8c6c4',
    errorBackground: '#442726',
    errorIcon: '#f1707b',
    blockingBackground: '#442726',
    blockingIcon: '#f1707b',
    severeWarningBackground: '#4f2a0f',
    severeWarningIcon: '#fce100',
    successBackground: '#393d1b',
    successIcon: '#92c353',
    warningBackground: '#433519',
    warningIcon: '#c8c6c4'
  }
};
